var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.72543 17.0865H16.2754C17.5588 17.0865 18.3588 15.6948 17.7171 14.5865L11.4421 3.74482C10.8004 2.63649 9.20043 2.63649 8.55876 3.74482L2.28376 14.5865C1.64209 15.6948 2.44209 17.0865 3.72543 17.0865ZM10.0004 11.2532C9.54209 11.2532 9.16709 10.8782 9.16709 10.4198V8.75316C9.16709 8.29482 9.54209 7.91982 10.0004 7.91982C10.4588 7.91982 10.8338 8.29482 10.8338 8.75316V10.4198C10.8338 10.8782 10.4588 11.2532 10.0004 11.2532ZM10.8338 14.5865H9.16709V12.9198H10.8338V14.5865Z",
    fill: "#EAAE37"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.a50c5c28763c1240e63624b9001efe0e.svg";
export { ForwardRef as ReactComponent };